module.exports = __webpack_public_path__ + "images/shortleaselandda49f47a701c5b36f607c626e2c9e770.png";